const clickOffer = () => {
  const currentPlan = document.querySelectorAll(".offer");

  currentPlan.forEach((offer) => {
    offer.addEventListener("click", (e) => {
      e.preventDefault();
      toggleClassOffer()
      const currentFlavor = e.currentTarget.getAttribute('data-flavor')
      const flavorArrow = document.querySelector(`.arrow--${currentFlavor}`)
      const flavorImage = document.querySelectorAll(`.flavor__img--${currentFlavor}`)
      const flavorText = document.querySelectorAll(`.flavor__text--${currentFlavor}`)
      const productLinks = document.querySelectorAll('.product__link')

      flavorArrow.classList.add("tw-block");
      flavorArrow.classList.remove("tw-hidden");

      flavorImage.forEach((image) => {
        image.classList.add("tw-block");
        image.classList.remove("tw-hidden");
      })

      flavorText.forEach((text) => {
        text.classList.add("tw-block");
        text.classList.remove("tw-hidden");
      })

      // リンク先をフレーバーに応じて変更
      productLinks.forEach((link) => {
        const urlChoco = link.getAttribute('data-url-choco')
        const urlMatcha = link.getAttribute('data-url-matcha')
        if (currentFlavor === 'choco') {
          link.setAttribute('href', urlChoco)
        } else if (currentFlavor === 'matcha') {
          link.setAttribute('href', urlMatcha)
        }
      })

      e.currentTarget.classList.add('tw-border-[#FFFF05]', 'tw-border-[3px]', 'md:tw-border-[6px]')
      e.currentTarget.classList.remove('tw-brightness-50')
    })
  })
}

const toggleClassOffer = () => {
  const currentPlan = document.querySelectorAll(".offer");
  const arrows = document.querySelectorAll('.arrow');
  const flavorImages = document.querySelectorAll('.flavor__img');
  const flavorText = document.querySelectorAll('.flavor__text');

  currentPlan.forEach((offer) => {
    offer.classList.remove('tw-border-[3px]', 'md:tw-border-[6px]', 'tw-border-[#FFFF05]')
    offer.classList.add('tw-brightness-50')
  })

  arrows.forEach((arrow) => {
    arrow.classList.add('tw-hidden')
  })

  flavorImages.forEach((flavor) => {
    flavor.classList.add('tw-hidden')
  })

  flavorText.forEach((flavor) => {
    flavor.classList.add('tw-hidden')
  })
}

const clickBuy = () => {
  const buyFlavorSelectors = document.querySelectorAll(".buy-flavor-selector");

  buyFlavorSelectors.forEach((selector) => {
    selector.addEventListener("click", (e) => {
      e.preventDefault();
      toggleClassBuy()
      const currentFlavor = e.currentTarget.getAttribute('data-flavor')
      const flavorArrow = document.querySelector(`.buy-arrow--${currentFlavor}`)
      const flavorImage = document.querySelectorAll(`.buy-flavor__img--${currentFlavor}`)
      const flavorText = document.querySelectorAll(`.buy-flavor__text--${currentFlavor}`)
      const productLinks = document.querySelectorAll('.buy-product-link')

      flavorArrow.classList.add("tw-block");
      flavorArrow.classList.remove("tw-hidden");

      flavorImage.forEach((image) => {
        image.classList.add("tw-block");
        image.classList.remove("tw-hidden");
      })

      flavorText.forEach((text) => {
        text.classList.add("tw-block");
        text.classList.remove("tw-hidden");
      })

      // リンク先をフレーバーに応じて変更
      productLinks.forEach((link) => {
        const urlChoco = link.getAttribute('data-url-choco')
        const urlMatcha = link.getAttribute('data-url-matcha')
        if (currentFlavor === 'choco') {
          link.setAttribute('href', urlChoco)
        } else if (currentFlavor === 'matcha') {
          link.setAttribute('href', urlMatcha)
        }
      })

      e.currentTarget.classList.add('tw-border-[#E51473]', 'tw-border-[3px]', 'md:tw-border-[6px]')
      e.currentTarget.classList.remove('tw-brightness-50')
    })
  })
}

const toggleClassBuy = () => {
  const buyFlavorSelectors = document.querySelectorAll(".buy-flavor-selector");
  const arrows = document.querySelectorAll('.buy-arrow');
  const flavorImages = document.querySelectorAll('.buy-flavor__img');
  const flavorText = document.querySelectorAll('.buy-flavor__text');

  buyFlavorSelectors.forEach((selector) => {
    selector.classList.remove('tw-border-[3px]', 'md:tw-border-[6px]', 'tw-border-[#E51473]')
    selector.classList.add('tw-brightness-50')
  })

  arrows.forEach((arrow) => {
    arrow.classList.add('tw-hidden')
  })

  flavorImages.forEach((flavor) => {
    flavor.classList.add('tw-hidden')
  })

  flavorText.forEach((flavor) => {
    flavor.classList.add('tw-hidden')
  })
}

const smoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href')

      if (href.startsWith('#') && href.length > 1) {
        const targetElement = document.querySelector(href)

        if (targetElement) {
          e.preventDefault()
          targetElement.scrollIntoView({ behavior: 'smooth' })
        }
      }
    })
  })
}

clickOffer()
clickBuy()
smoothScroll()